import { serviceUserFrag } from '../../../../../services/types/user.types';
import { voucherPrescribedMedicalProcedureFrag } from '../../../../../services/types/voucher.types';

export const voucherPrevFrag = `
    id
    sequenceNumber
    issueDate
    validTo
    closureDate
    voucherTo    
`;

export const vouchersFrag = `
    id
    voucherPrevId
    voucherPrev {
        ${voucherPrevFrag}
    }
    type
    insuranceNumber
    insuranceAbbr
    insuranceType
    insuredSince
    sequenceNumber
    issueDate
    validTo
    closureDate
    voucherTo
    doctorId
    doctor {
        ${serviceUserFrag}
    }
    prescribedProcedures {
        ${voucherPrescribedMedicalProcedureFrag}
    }
    primaryDiagnosis {
        code
        name
        sex
        ageFrom
        ageTo
        sign
        selectable
    }
    secondaryDiagnoses {
        reporting
        diagnosis {
            code
            name
            sex
            ageFrom
            ageTo
            sign
            selectable
        }
    }
    compensation {
        code
        description
        priority
    }
    note
    situation
`;
